import { render, staticRenderFns } from "./NursePatientDetail.vue?vue&type=template&id=519b7283&"
import script from "./NursePatientDetail.vue?vue&type=script&lang=js&"
export * from "./NursePatientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports